module.exports = __webpack_public_path__ + "d4b4b51261bb348e4a3fb70eb7fcb404.svg";